import { jsx as _jsx } from "react/jsx-runtime";
const GenericLink = ({
  children,
  dataSpeculationTarget,
  external,
  href,
  LinkComponent,
  LinkComponentProps,
  onClick
}) => {
  return /*#__PURE__*/_jsx(LinkComponent
  // Keep LinkComponentProps at the top so that they can be overriden
  , Object.assign({}, LinkComponentProps, {
    "data-speculation-target": dataSpeculationTarget,
    external: external,
    href: href,
    onClick: onClick,
    children: children
  }));
};
export default GenericLink;